import React from 'react';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import SpaceDashboardIcon from '@mui/icons-material/SpaceDashboard';
import { Button } from '@zawarski/eti-typescript-components';
import { WidgetProps } from './Widget.props';
import { PROGRAMS_NAMES } from 'data/index';

const WidgetView: React.FC<WidgetProps> = ({
  onAddWidget,
  isSplit = false,
  columnId,
  widgetIndex,
  quickPickList,
  onAddProgram,
}) => {
  return (
    <div
      className={`w-full h-[calc(100%-32px)] bg-lynch-100 rounded-[6px] shadow-md p-2 flex flex-col justify-between`}>
      <div
        className='flex-grow flex flex-col items-center justify-center cursor-pointer border border-dashed border-lynch-200'
        style={{ borderWidth: '2px' }}
        onClick={() => onAddWidget(columnId, widgetIndex)}>
        <AddCircleIcon sx={{ color: 'blue' }} fontSize='medium' />
        <div className='text-lynch-300 mt-2'>Add program</div>
      </div>

      <div className='mt-4'>
        <p className='text-lynch-400 mb-1'>Quick Pick</p>
        <div className='space-y-1'>
          {quickPickList.map((program, index) => {
            const displayName = PROGRAMS_NAMES.find((p) => p.value === program)?.label;
            if (index < 3) {
              return (
                <Button
                  key={program}
                  startIcon={<SpaceDashboardIcon />}
                  color='secondary'
                  fullWidth
                  className='!text-lynch-500 !flex !justify-start !font-500 !bg-white-50'
                  onClick={() => onAddProgram(program, columnId, widgetIndex)}>
                  {displayName}
                </Button>
              );
            }
          })}
        </div>
      </div>
    </div>
  );
};

export default WidgetView;
